"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THUMBNAIL_MAX_AUTHORIZED_SIZE = 5 * Math.pow(1024, 2);
//# sourceMappingURL=widget.js.map